
import { Modal, Button } from "react-bootstrap";


function ModalCard({ show, handleClose, project }) {

    return (
        <Modal show={show} onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter" centered style={{ border: 0 }}>
            <Modal.Header closeButton style={{ backgroundColor: "#000" }}>
                <Modal.Title>{project.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#000" }}>
                <p className="text-center" style={{ color: "#fff" }}>{project.data.description}</p>
                <p className="text-center" style={{ color: "#fff", fontWeight: "bold" }}>Technologies</p>
                <div className="d-flex justify-content-center">
                    <div>
                        {project.data.technologies.map((i) => <li key={i} style={{ color: "rgb(255, 255, 255, 0.8)" }}>{i}</li>)}
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#000", border: 0 }} >
                <Button variant="light" href={project.data.link}>Try it now</Button>
                {
                    project.code ?
                        <Button variant="light" href={project.code}>Code Example</Button> : <></>
                }
            </Modal.Footer>
        </Modal>
    );
}


export default ModalCard;